import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  children: [],
  vaccinations: [],
  currentChild: null,
  loading: false,
  error: null,
  sessionRefreshTrigger: 0,
};

const uwinSlice = createSlice({
  name: 'uwin',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setChildren: (state, action) => {
      state.children = action.payload;
    },
    setVaccinations: (state, action) => {
      state.vaccinations = action.payload;
    },
    setCurrentChild: (state, action) => {
      state.currentChild = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    triggerSessionRefresh: (state) => {
      state.sessionRefreshTrigger += 1;
    },
  },
});

export const { setLoading, setChildren, setVaccinations, setCurrentChild, setError, clearError, triggerSessionRefresh } = uwinSlice.actions;
export default uwinSlice.reducer;